import { clsx } from 'clsx';
import * as React from 'react';
import * as style from './Overlay.css';

interface IOverlayProps {
  children: React.ReactNode;
  onClose(): void;
  outside?: boolean;
  zIndex?: number;
  className?: string;
  open?: boolean;
}

/**
 * Затеняющая подложка
 */
export function Overlay({ children, zIndex, outside, onClose, open = false }: IOverlayProps): JSX.Element {
  const onClick = React.useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (outside && e.currentTarget === e.target) {
        onClose();
      }
    },
    [onClose, outside],
  );

  return (
    <div className={clsx(style['overlay'], open && style['open'])} style={{ zIndex }} onClick={onClick}>
      {children}
    </div>
  );
}
